import React from "react";

const addButtonLabels = {
  users: "Add User",
  decks: "Add Deck",
  cardTypes: "Add Card Type",
  symbols: "Add Symbol",
  cards: "Add Card"
};

const AdminSidePanel = ({
  activeTab,
  showAddForm,
  setShowAddForm,
  editingItem,
  renderAddForm,
  renderEditForm,
  showAddCardForm,
  setShowAddCardForm,
  editingCard,
  setEditingCard,
  selectedItem,
  setSelectedItem,
  itemDetails,
  loadingDetails,
  onEditReportCard,
  onEditReportDeck,
  onEditReportUser
}) => {
  // Show Add button only for tabs that support it
  const showAddButton = ["users", "decks", "cardTypes", "symbols", "cards"].includes(activeTab);
  
  // Show details when an item is selected
  const showDetails = selectedItem && !showAddForm && !editingItem && !showAddCardForm && !editingCard;
  
  // Show edit forms for reports tab OR when editing card/deck/user from reports
  const showReportEditForms = activeTab === "reports" || editingCard || (editingItem && ["cards", "decks", "users"].includes(editingItem.type) && activeTab === "reports");

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {showAddButton && (
        <div style={{ marginBottom: '20px' }}>
          <button className="small-action-btn add" style={{ width: '100%', padding: '10px', fontSize: '1rem' }} onClick={() => setShowAddForm(activeTab)}>
            {addButtonLabels[activeTab]}
          </button>
        </div>
      )}
      
      {showAddForm === activeTab && renderAddForm()}
            {editingItem && editingItem.type === activeTab && renderEditForm()}
            {activeTab === "cards" && (
              <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                {showAddCardForm && renderAddForm()}
                {editingCard && renderEditForm()}
              </div>
            )}
            {showReportEditForms && (
              <div style={{ flex: 1, overflowY: 'auto' }}>
                {selectedItem && !editingItem && !editingCard && (
                  <div style={{ padding: '20px' }}>
                    <h3>Report Details</h3>
                    {loadingDetails ? <p>Loading...</p> : itemDetails && (
                      <>
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
                          <tbody>
                            <tr>
                              <td style={{ padding: '8px 0', fontWeight: 'bold', color: 'var(--text-secondary, #666)', width: '120px' }}>Report ID</td>
                              <td style={{ padding: '8px 0', color: 'var(--text, #222)' }}>{itemDetails.report_id}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: '8px 0', fontWeight: 'bold', color: 'var(--text-secondary, #666)' }}>Status</td>
                              <td style={{ padding: '8px 0' }}>
                                <span style={{ 
                                  padding: '4px 8px', 
                                  borderRadius: '4px', 
                                  fontSize: '12px',
                                  fontWeight: 'bold',
                                  background: itemDetails.status === 'open' ? '#ffc107' : '#28a745',
                                  color: itemDetails.status === 'open' ? '#212529' : '#fff'
                                }}>
                                  {itemDetails.status}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: '8px 0', fontWeight: 'bold', color: 'var(--text-secondary, #666)' }}>Card ID</td>
                              <td style={{ padding: '8px 0', color: 'var(--text, #222)' }}>{itemDetails.card_id}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: '8px 0', fontWeight: 'bold', color: 'var(--text-secondary, #666)' }}>Deck</td>
                              <td style={{ padding: '8px 0', color: 'var(--text, #222)' }}>{itemDetails.deck_name || `Deck ${itemDetails.deck_id}`}</td>
                            </tr>
                            <tr>
                              <td style={{ padding: '8px 0', fontWeight: 'bold', color: 'var(--text-secondary, #666)' }}>Reported By</td>
                              <td style={{ padding: '8px 0', color: 'var(--text, #222)' }}>{itemDetails.reported_by_name} ({itemDetails.reported_by_email})</td>
                            </tr>
                            <tr>
                              <td style={{ padding: '8px 0', fontWeight: 'bold', color: 'var(--text-secondary, #666)' }}>Created</td>
                              <td style={{ padding: '8px 0', color: 'var(--text, #222)' }}>{new Date(itemDetails.created_at).toLocaleString()}</td>
                            </tr>
                            {itemDetails.feedback && (
                              <tr>
                                <td style={{ padding: '8px 0', fontWeight: 'bold', color: 'var(--text-secondary, #666)' }}>Admin Feedback</td>
                                <td style={{ padding: '8px 0', color: '#2e7d32' }}>{itemDetails.feedback}</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        <div style={{ marginTop: 20, display: 'flex', flexDirection: 'column', gap: 8 }}>
                                            <button 
                                              className="small-action-btn edit"
                                              onClick={() => onEditReportCard && onEditReportCard(itemDetails)}
                                              disabled={loadingDetails}
                                              style={{ width: '100%' }}
                                            >
                                              Edit Card
                                            </button>
                                            <button 
                                              className="small-action-btn edit"
                                              onClick={() => onEditReportDeck && onEditReportDeck(itemDetails)}
                                              disabled={loadingDetails}
                                              style={{ width: '100%' }}
                                            >
                                              Edit Deck
                                            </button>
                                            <button 
                                              className="small-action-btn edit"
                                              onClick={() => onEditReportUser && onEditReportUser(itemDetails)}
                                              disabled={loadingDetails}
                                              style={{ width: '100%' }}
                                            >
                                              Edit User
                                            </button>
                                          </div>
                      </>
                    )}
                  </div>
                )}
                {(editingItem && ["cards", "decks", "users"].includes(editingItem.type) && activeTab === "reports") && renderEditForm()}
                {(editingCard) && renderEditForm()}
                {!selectedItem && !editingItem && !editingCard && (
                  <div style={{ padding: '20px', color: '#666', fontSize: '14px' }}>
                    <p>Click on a report in the list to view details here.</p>
                    <p>Use the "Close/Reopen" button in the table to change report status.</p>
                  </div>
                )}
              </div>
            )}
      {showDetails && activeTab !== "reports" && (
        <div style={{ flex: 1, overflowY: 'auto', padding: '20px' }}>
          <h3>Record Details</h3>
          {loadingDetails ? <p>Loading...</p> : itemDetails && (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
              <tbody>
                {Object.entries(itemDetails).map(([key, value]) => (
                  <tr key={key}>
                    <td style={{ padding: '8px 0', fontWeight: 'bold', color: 'var(--text-secondary, #666)', width: '120px' }}>
                      {key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' ')}
                    </td>
                    <td style={{ padding: '8px 0', color: 'var(--text, #222)' }}>
                      {value === null || value === undefined ? '—' : 
                       typeof value === 'object' ? JSON.stringify(value) : 
                       value instanceof Date ? value.toLocaleString() : value}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
      {!showAddButton && !selectedItem && activeTab !== "reports" && activeTab !== "overview" && activeTab !== "languages" && (
        <div style={{ padding: '20px', color: '#666', fontSize: '14px' }}>
          <p>Select a record from the list to view details here.</p>
        </div>
      )}
    </div>
  );
};

export default AdminSidePanel;